/* global pyg */
import { observable } from 'mobx'
import { action } from 'mobx'
import _ from 'lodash'

const doctorsStore = observable({
  data: null,
  hdept: "一般內科部",
  hdepts: [],
  viewData: [],
  totalSearch: [],
  team: "",
  teams: [],
  eachTeam: null,
  DocEmpNo: '',
  pathname: '',
  DocDetail: {
    Degree: [],
    EmpNo: '',
    Experience: '',
    GoogleScholar: '',
    HdeptName: '',
    HdeptSubName: '',
    Introduce: '',
    JobPosition: [],
    MedicalTeams: [],
    NameCh: '',
    NameEn: '',
    ProAcademy: [],
    Reasearch: [],
    Skills: [],
    OpdFlag: '',
    Training: []
  },
  keyword: '',
  filterDocName: null,
  parsedHashDetail: null,
  open: false,
  loadingStatus: 'loading',
})

const filterViewData = (hdept) => {
  if (hdept.length > 0) {
    doctorsStore.viewData = _.filter(doctorsStore.data, (x) => {
      return x['HdeptName'] === hdept
    })
  } else {
    doctorsStore.viewData = doctorsStore.data
  }
}

const filterViewTeam = (team) => {
  const fData = _.filter(doctorsStore.eachTeam, (x) => {
    return x['MedicalTeams'] === team
  })
  _.forEach(fData, function (item) {
    _.forEach(item, function (val) {
      doctorsStore.viewData = val
    })
  })
}

const loadData = (value) => {
  // const lurl = "https://patient.kfsyscc.org/pygg/doc_info.json"
  // fetch(lurl, {}).then((response) => {
  //   return response.json()
  // })
  pyg.api_doc_info_doc_info()
    .then((data) => {

      // filter PauseFlag <> 'Y' show List
      doctorsStore.data = _.reject(data, { 'PauseFlag': 'Y' })
      let handle_data = data.map(o => ({...o, MedicalTeams: o.MedicalTeams === null ? [] : o.MedicalTeams }))

      doctorsStore.hdepts = _.orderBy(_.uniq(_.map(doctorsStore.data, (x) => { return x.HdeptName })))
      if (doctorsStore.keyword === '') {
        filterViewData(doctorsStore.hdept)
      } else {
        return false
      }

      /* 醫師中英文與部門 Array */
      let searchNameCh = _.map(doctorsStore.data, (c) => {
        return c.NameCh
      })
      let searchNameEn = _.map(doctorsStore.data, (e) => {
        return e.NameEn
      })
      let searchHdeptName = _.map(doctorsStore.data, (h) => {
        return h.HdeptName
      })
      doctorsStore.totalSearch = _.unionBy(searchNameCh, searchNameEn, searchHdeptName)

      // *** 將團隊合併 ***
      const preMedicalTeam = _.orderBy(_.map(handle_data, (x) => { return x.MedicalTeams }))
      let MedicalTeam = []
      _.forEach(preMedicalTeam, (item) => { _.forEach(item, (item2) => { MedicalTeam.push(item2) }) })
      doctorsStore.teams = _.uniq(MedicalTeam)

      let teams = []
      for (let i = 0; i < handle_data.length; i++) {
        for (let j = 0; j < handle_data[i].MedicalTeams.length; j++) {
          teams.push(handle_data[i].MedicalTeams[j])
        }
      }

      teams = _.orderBy(_.uniq(teams), [function (o) { return o.MedicalTeams; }])
      for (let i = 0; i < teams.length; i++) {
        teams[i] = {
          MedicalTeams: teams[i],
          Data: [],
        };
      }

      // 每抓到一個資料tx，就走訪資料，看誰包函tx的，加入新表格。
      for (let i = 0; i < teams.length; i++) {
        // teams[i].MedicalTeams代表t1或t2...t5
        for (let j = 0; j < handle_data.length; j++) {
          for (let k = 0; k < handle_data[j].MedicalTeams.length; k++) {
            // 如果 data 裡 NameCh 的 MedicalTeams 裡面有"teams1"的話，就把 NameCh 加入新表格裡。
            if (handle_data[j].MedicalTeams[k] === teams[i].MedicalTeams) {
              teams[i].Data.push(handle_data[j])
            }
          }
        }
      }

      doctorsStore.eachTeam = teams
      filterViewTeam(doctorsStore.team)

      /* 如果頁面在 /detail 時，才執行 */
      if (doctorsStore.pathname === '/detail') {
        const filterDocItem = _.filter(handle_data, (o) => {
          if (o.EmpNo === value) {
            return o.EmpNo === value
          } else if (!_.includes(o.EmpNo, value)) {
            doctorsStore.data = 'No Data'
          } else {
            return null
          }
        })
        if (!_.isEmpty(filterDocItem)) {
          doctorsStore.setDocItem(filterDocItem)
        } else {
          return false
        }
      } else {
        return false
      }

    }).catch(function (ex) {
      console.log('other:' + ex)
    })
}

function setSearch(value) {
  doctorsStore.setKeyword(value);

  let filterDocName = _.filter(doctorsStore.data, function (item) {
    // let a = item.NameCh.indexOf(value)>-1;
    // let b = _.toUpper(item.NameEn).includes(_.toUpper(value));
    // let c = item.HdeptName.indexOf(value)>-1;

    return (
      item.NameCh.indexOf(value) > -1 ||
      _.toUpper(item.NameEn).includes(_.toUpper(value)) ||
      item.HdeptName.indexOf(value) > -1
    )
  })

  doctorsStore.viewData = filterDocName
  doctorsStore.team = ""
  doctorsStore.hdept = ""
}

_.assign(doctorsStore, {
  setHdept: action(function (val) {
    this.hdept = val
    this.team = ""
    filterViewData(val)
  }),
  setTeam: action(function (val) {
    this.team = val
    this.hdept = ""
    filterViewTeam(val)
  }),
  setSearch: action(function (value) {
    setSearch(value);
  }),
  setDocDetail: action(function (item) {
    this.DocDetail = item
  }),
  setLoadData: action(function (value) {
    loadData(value)
  }),
  setKeyword: action(function (val) {
    this.keyword = val;
  }),
  setDocItem: action(function (value) {
    doctorsStore.DocDetail.Degree = value[0].Degree
    doctorsStore.DocDetail.EmpNo = value[0].EmpNo
    doctorsStore.DocDetail.Experience = value[0].Experience
    doctorsStore.DocDetail.GoogleScholar = value[0].GoogleScholar
    doctorsStore.DocDetail.HdeptName = value[0].HdeptName
    doctorsStore.DocDetail.HdeptSubName = value[0].HdeptSubName
    doctorsStore.DocDetail.Introduce = value[0].Introduce
    doctorsStore.DocDetail.JobPosition = value[0].JobPosition
    doctorsStore.DocDetail.MedicalTeams = value[0].MedicalTeams
    doctorsStore.DocDetail.NameCh = value[0].NameCh
    doctorsStore.DocDetail.NameEn = value[0].NameEn
    doctorsStore.DocDetail.ProAcademy = value[0].ProAcademy
    doctorsStore.DocDetail.Research = value[0].Research
    doctorsStore.DocDetail.Skills = value[0].Skills
    doctorsStore.DocDetail.OpdFlag = value[0].OpdFlag
    doctorsStore.DocDetail.Training = value[0].Training
  })
})

export default doctorsStore



// WEBPACK FOOTER //
// ./src/stores/doctors.js